import { getRandomNumber } from "@shared/utility/formats/random-number";
import { Skeleton } from "primereact/skeleton";

export interface SkeletonAttachmentProps {
  count: number;
  mode?: "table" | "grid" | "list";
}

export function SkeletonAttachment({
  count,
  mode = "table",
}: SkeletonAttachmentProps) {
  const tableStructure = [...Array(count)].map((e, i) => (
    <tr key={i}>
      <td className="p-3">
        <Skeleton width="120px" height="1.2rem" />
      </td>
      <td className="p-3">
        <Skeleton width="200px" height="200px" borderRadius="8px" />
      </td>
    </tr>
  ));

  const gridStructure = [...Array(count)].map((e, i) => (
    <div key={i} className="col-12 md:col-6 lg:col-4 xl:col-3 p-2">
      <div className="border-1 border-300 border-round p-3">
        <Skeleton
          width="100%"
          height="200px"
          borderRadius="8px"
          className="mb-3"
        />
        <Skeleton width="60%" height="1rem" className="mb-2" />
        <Skeleton width="40%" height="0.8rem" />
      </div>
    </div>
  ));

  const listStructure = [...Array(count)].map((e, i) => (
    <li className="mb-4 p-3 border-1 border-300 border-round" key={i}>
      <div className="flex align-items-center">
        <Skeleton
          width="100px"
          height="100px"
          borderRadius="8px"
          className="mr-3"
        />
        <div style={{ flex: "1" }}>
          <Skeleton width="70%" height="1.2rem" className="mb-2" />
          <Skeleton width="50%" height="1rem" className="mb-2" />
          <Skeleton width="30%" height="0.8rem" />
        </div>
        <div className="flex flex-column align-items-end">
          <Skeleton
            width="60px"
            height="2rem"
            borderRadius="4px"
            className="mb-2"
          />
          <Skeleton width="80px" height="1.5rem" borderRadius="4px" />
        </div>
      </div>
    </li>
  ));

  const getStructure = () => {
    switch (mode) {
      case "table":
        return (
          <div className="p-datatable p-component">
            <div className="p-datatable-wrapper">
              <table className="p-datatable-table">
                <thead className="p-datatable-thead">
                  <tr>
                    <th className="p-3">
                      <Skeleton width="60px" height="1rem" />
                    </th>
                    <th className="p-3">
                      <Skeleton width="100px" height="1rem" />
                    </th>
                  </tr>
                </thead>
                <tbody className="p-datatable-tbody">{tableStructure}</tbody>
              </table>
            </div>
          </div>
        );

      case "grid":
        return <div className="grid">{gridStructure}</div>;

      case "list":
      default:
        return <ul className="m-0 p-0 list-none">{listStructure}</ul>;
    }
  };

  return <div className="skeleton-attachment">{getStructure()}</div>;
}

export default SkeletonAttachment;
